/**
 * Hostfile and configuration utility to wait for hostname file on disk
 * @module Host
 */
const {
  FileWatcher
} = require("./filewatcher");
const {
  paths
} = require("./paths");

/**
 * Host Class - exposes a getter for retrieving hostfile
 */
class Host {
  /**
   * Creates a Hostfile object that will look for QlikSense host 
   * file in a specifiecd folder
   * @param {string} hostFileRoot - A path to the root folder 
   * where the host file is expected to be.
   */
  constructor(hostFileRoot) {
    this.hostFileWatcher = new FileWatcher(
      hostFileRoot || paths.senseDataPath,
      ["host.cfg"]
    );
  }

  /**
   * Gets the host file content when it is safe to get it
   * @returns { Promise<Object> } A promise that resolves to 
   * an object containing the host or rejects with an error if the 
   * files couldn't be read.
   */
  get() {
    return this.hostFileWatcher.get().then(files => {
      const hostfile = files.get("host.cfg");
      return new Buffer(hostfile.toString(), "base64").toString();
    });
  }
}

/**
 * Singleton object for hostfile
 */
const host = new Host();

module.exports = {
  host,
  Host
};
